import * as React from 'react'
import { animate, useMotionValue } from 'motion/react'

import { Flex, Progress, Text } from '@buffer-mono/popcorn'

import type { CommentsScoreMetric } from '~publish/gql/graphql'

import { getScoreColors } from '../../util/commentScoreTheme'

const Metric = ({
  label,
  value,
}: {
  label: string
  value: number
}): JSX.Element => {
  const colors = getScoreColors(value)
  const progress = useMotionValue(0)
  const [current, setCurrent] = React.useState(0)

  React.useEffect(() => {
    const controls = animate(progress, value, {
      duration: 1.2,
      ease: [0.31, 0.05, 0.28, 0.85],
      onUpdate: (latest) => setCurrent(latest),
    })
    return controls.stop
  }, [progress, value])

  return (
    <Flex direction="column" gap="2xs" style={{ width: '100%' }}>
      <Flex justify="between" style={{ width: '100%' }}>
        <Text size="sm" weight="bold" color="subtle">
          {label}
        </Text>
        <Text size="sm" weight="bold" color="subtle">
          {Math.round(current)}%
        </Text>
      </Flex>
      <Progress
        value={current}
        variant="classic"
        size="small"
        style={
          {
            '--progress-fg-color': colors.progressColor,
            '--progress-value': current,
            '--progress-max': 100,
          } as React.CSSProperties
        }
      />
    </Flex>
  )
}

export const DetailedMetrics = ({
  responseRate,
  responseSpeed,
  consistency,
}: {
  responseRate: CommentsScoreMetric
  responseSpeed: CommentsScoreMetric
  consistency: CommentsScoreMetric
}): JSX.Element => {
  return (
    <Flex direction="column" gap="md" style={{ width: '100%' }}>
      <Metric label="Response rate" value={responseRate.percentage} />
      <Metric label="Response speed" value={responseSpeed.percentage} />
      <Metric label="Consistency" value={consistency.percentage} />
    </Flex>
  )
}
